import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Null_School_Or_Country_Attendees } from "../../../Misc/api/Get_Null_School_Or_Country_Attendees";

function AttendeesToSchoolTODO() {
  const { logout } = StaffuseAuth();

  const [Attendees, setAttendees] = useState([]);
  useEffect(() => {
    Get_Null_School_Or_Country_Attendees(
      "Registers_2025",
      "All",
      setAttendees,
      100000,
      "All",
      "All",
      logout
    );
  }, []);

  function handleGoToAttendeeSchoolAssigner(e) {
    e.preventDefault();
    window.open(`/Staff/AssignAttendeeToSchool`, "_blank");
  }

  return (
    <>
      {Attendees.length > 0 ? (
        <Container maxWidth="sm">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            Attendees ready to be assigned to a School: {Attendees.length}
          </Box>
          <br></br>
          <button onClick={(e) => handleGoToAttendeeSchoolAssigner(e)}>
            Go To
          </button>
          <br></br>
          <br></br>
        </Container>
      ) : (
        <> </>
      )}
    </>
  );
}

export default AttendeesToSchoolTODO;
